<template>
  <div class="const">
    <div class="video" v-if="videoShow">
      <div
        class="colse"
        style="position: absolute;right:20px;top:20px;cursor: pointer;"
        v-on:click="closeVideo()"
      >
        <i class="el-icon-circle-close" style="color:#fff;font-size:40px"></i>
      </div>
      <div style="width:100%;height:100%;display:flex;align-items: center;justify-content: center;">
        <video :src="videosrc" controls="controls"></video>
      </div>
    </div>
    <div class="sear">
      <label>从</label>
      <el-date-picker v-model="startDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <label>到</label>
      <el-date-picker v-model="endDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <el-button type="primary" style="margin-left:20px;" v-on:click="tionSears()">确定</el-button>
    </div>
    <div
      class="jtCon"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <div class="jtCons" v-for="item in videoLIst" :key="item.id">
        <div
          class="jtCon_pic"
          v-on:mouseover="item.checks=true"
          v-on:mouseleave="item.checks=false"
        >
          <div class="demo-image__preview">
            <div class="grayPic" v-if="item.checks" v-on:click="videoPlay(item)">
              <div style="display: flex;align-items: center;justify-content: center;height:100%">
                <i class="el-icon-video-play" style="font-size:40px"></i>
              </div>
            </div>
            <img :src="item.v_cover" style="height:150px;" v-on:click="videoPlay(item)" />
          </div>
        </div>
        <div class="jtCon_tit">{{item.v_title}}</div>
        <div class="jtCon_date">{{item.v_time}}</div>
      </div>
    </div>
    <el-pagination
      small
      layout="prev, pager, next"
      :total="total"
      :page-size="pagesize"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      srcList: [],
      videoLIst: [],
      page: 0,
      pagesize: 8,
      total: 0,
      loading: false,
      videosrc: "",
      videoShow: false
    };
  },
  created() {
    let timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
    let SevenDayAgo = timeStamp - 86400 * 7;
    let start_time = SevenDayAgo;
    this.startDate = this.timestampToTime(start_time);
    let end_time =
      new Date(new Date().setHours(23, 59, 59, 0)).getTime() / 1000;
    this.endDate = this.timestampToTime(end_time);
    this.tionSear();
  },
  methods: {
    tionSears() {
      this.page = 0;
      this.tionSear();
    },
    tionSear() {
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      const oauth_token = sessionStorage.getItem("oauth_token");
      this.loading = true;
      let macSplit = mac.replace(/-/g, "");
      let start_time = new Date(this.startDate).getTime() / 1000;
      let end_time = new Date(this.endDate).getTime() / 1000;
      const page = this.page;
      const pageSize = this.pagesize;
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getLogVideo&mac=${mac}&oauth_token=${oauth_token}&page=${page}&page_count=${pageSize}&start_time=${start_time}&end_time=${end_time}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.data.table.length > 0) {
            this.srcList = [];
            for (let o of res.data.table) {
              o.v_path = `http://${user_name}_${macSplit}.ng.360mon.cn:90/${o.v_path}`;
              o.v_cover = `http://${user_name}_${macSplit}.ng.360mon.cn:90/${o.v_cover}`;
              o.v_time = this.timestampToTime(o.v_time);
              o["checks"] = false;
              this.srcList.push(o.v_cover);
            }
          }
          this.loading = false;
          this.videoLIst = res.data.table;
          this.total = res.data.total;
        })
        .catch(res => {
          this.loading = false;
          console.log(res);
        });
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      this.tionSear();
    },
    videoPlay(item) {
      this.videosrc = item.v_path;
      this.videoShow = true;
    },
    closeVideo() {
      this.videoShow = false;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>
<style scoped>
.const /deep/.el-image-viewer__close {
  color: #ffffff !important;
}
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: auto;
}
.const .colse i {
  width: 100%;
}
.const .video {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000000;
}
.const .sear {
  margin-left: 26px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  padding-top: 20px;
}
.const .sear label {
  margin: 0 15px;
}
.const .jtCon {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: left;
  margin: 15px 26px 0 26px;
  height: calc(100vh - 350px);
  overflow: auto;
}
.const .jtCon .jtCons {
  text-align: center;
  width: 22%;
  margin: 50px 1.5% 0 1.5%;
  cursor: pointer;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.const .jtCon .jtCons .demo-image__preview {
  position: relative;
}
.const .jtCon .jtCons .grayPic {
  position: absolute;
  height: 100%;
  width: 100%;
}
.const .jtCon .jtCons.on {
  background: #000;
}

.const .jtCon .jtCon_pic {
  width: 100%;
}
.const .jtCon .jtCon_pic img {
  height: 161px;
}
.const .jtCon .jtCon_tit {
  margin-top: 11px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(60, 60, 60, 1);
}
.const .jtCon .jtCon_date {
  margin-top: 5px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
}
.const /deep/.el-pagination {
  margin-top: 15px;
  text-align: right;
  padding-bottom: 15px;
}
</style>